const PAYLOAD_URL_RE = /^[^?]*\/_payload\.(?:json|js)(?:\?.*)?$/;

export function useNotFoundStatus() {
  const event = useRequestEvent();
  if (!event) {
    return;
  }

  const requestedUrl = event.node.req.originalUrl ?? event.path;
  if (PAYLOAD_URL_RE.test(requestedUrl)) {
    return;
  }

  event.node.res.statusCode = 404;
}
